__turbopack_context__.v({
  "richTextContainer": "RichTextContainer-module-scss-module__GXAk1a__richTextContainer",
});
